import { useQuery } from "@apollo/client";
import { GET_ALL_PERSONS } from "../api/get-all-persons/get-all-persons";
import { useMemo } from "react";
import { sortByString } from "@/shared/sorting";
import { MentionsOptionProps } from "antd/es/mentions";
import { usePersonNameString } from "@/modules/common/entities/person/person-name";
import { useTranslations } from "use-intl";

export function usePersonOptions() {
  const personName = usePersonNameString();
  const tc = useTranslations("Common");
  const hiddenWord = tc("Hidden");
  const { data, loading, previousData } = useQuery(GET_ALL_PERSONS);

  const persons = useMemo(() => {
    return (
      data?.findPersons?.content ?? previousData?.findPersons?.content ?? []
    );
  }, [data?.findPersons?.content, previousData?.findPersons?.content]);

  const options: MentionsOptionProps[] = useMemo(
    () =>
      persons
        .map((person) => {
          const label = personName(person);

          // Когда защита не отдала имени, подпись у всех закрытых людей одна и та же,
          // а упоминание подставляется поиском по подписи: без различителя «@Скрыто»
          // уехало бы к первому попавшемуся. Имя от защиты уже само по себе различает.
          return {
            value: person.id,
            label:
              label === hiddenWord
                ? `${label} · ${person.id.slice(0, 8)}`
                : label,
          };
        })
        .sort((a, b) => sortByString(a.label ?? "", b.label ?? "")),
    [persons, personName, hiddenWord],
  );

  return {
    persons,
    options,
    loading,
  };
}
